import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Modal } from 'react-bootstrap'
import { canEdit, canDelete } from '../../../../utils/modulePermissions';
import BreadcrumbHeading from '../../breadcrumbs/BreadcrumbHeading'
import DataTableRemote from '../../datatables/DataTableRemote'
import { Data, Columns, defaultSorted } from './ManageQuestionPaperData';
import CardLessDataTableWithSearch from '../../datatables/CardLessDataTableWithSearch';
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import moment from 'moment';
import AdaptiveExams from '../../adaptiveExams/AdaptiveExams';
import { components } from 'react-select'
import SelectDropDown from '../../selectdropdown/SelectDropDown';
import StudentAdaptiveExamReportModal from './StudentAdaptiveExamReportModal';
import MultiSelect from "react-multi-select-component";


// Role permissions for this page (/questions/manage-question-paper → "Manage_Exams",
// see MODULE_ROUTES in moduleAccessGuard).
//
// Match on module_key ONLY, never on module_name: "Online Exams" is the sidebar GROUP
// shared by Manage_Exams, Exam_Made_Easy, Quiz and View_Results, and can() allows an
// action when ANY matched row grants it — so matching the group name would let a role
// with edit on a sibling module inherit edit here.
const MANAGE_EXAMS_MODULE = ["Manage_Exams"];

const DropdownIndicator = (props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <i className="fal fa-angle-down" />
            </components.DropdownIndicator>
        )
    );
};


class ManageQuestionPaperSection extends Component {
    constructor(props) {
        super(props)

        this.state = {

            breadcrumbsData: {
                Title: "Manage Exam Papers"
            },
            tableHeaderData: {
                Title: 'Own Exam Papers'
            },
            activeTab: ManageQuestionPaperSection.resolveActiveTab(props),
            loader: 0,
            selectedExamValue: { value: 0, label: "Select Exams", subtype_id: 0 },
            selectedExamSubType: { value: 0, label: "Select Type" },
            selectedStudentModal: false,
            studentData: [],
            adaptiveExamGroupData: [],

            // Shown when a role without is_edit / is_delete clicks a row action.
            accessDeniedShow: false,

            // Filter States
            getBranchArr: [],
            getExamArr_filter: [],
            getClassArr_filter: [],
            getSectionArr_filter: [],
            branchSelectedvalue: [],
            examSelectedvalue_filter: [],
            classSelectedvalue_filter: [],
            sectionSelectedvalue_filter: [],
            showFilter: true
        }
    }

    // Map the URL slug (general/adaptive) to the numeric tab value, falling back
    // to navigation state and finally the General tab.
    static resolveActiveTab(props) {
        const tabParam = props?.match?.params?.tab;
        // Adaptive Exam is hidden — the tab below is commented out. This is also disabled so
        // /questions/manage-question-paper/adaptive can't reach it straight from the URL.
        // if (tabParam === "adaptive") return 2;
        if (tabParam === "general") return 1;
        if (props?.location?.state?.activeTab != undefined) return props.location.state.activeTab;
        return 1;
    }

    componentDidMount() {
        if (this.props.globals) {
            this.initializeFilterOptions();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.globals !== prevProps.globals) {
            this.initializeFilterOptions();
        }

        // Keep the active tab in sync when the URL changes (e.g. browser back/forward).
        if (this.props.match?.params?.tab !== prevProps.match?.params?.tab) {
            const urlTab = ManageQuestionPaperSection.resolveActiveTab(this.props);
            if (urlTab !== this.state.activeTab) {
                this.setState({ activeTab: urlTab });
            }
        }

        // Auto-select defaults for Adaptive Exam tab
        if (this.state.activeTab === 2) {
            const { getExamScheduleSubTypeQuestions, getAdaptiveExamGroups } = this.props;

            if (this.state.selectedExamSubType.value === 0 && getExamScheduleSubTypeQuestions && getExamScheduleSubTypeQuestions.length > 0) {
                const firstSubType = getExamScheduleSubTypeQuestions[0];
                const selectedOption = {
                    value: +firstSubType.schedule_sub_type_id,
                    label: firstSubType.schedule_sub_type,
                };

                const adaptiveExamGroupExam = getAdaptiveExamGroups.filter((item) => Number(item.schedule_sub_type_id) === Number(selectedOption.value));
                const item = adaptiveExamGroupExam?.[0] || {};

                if (item.group_exam_id) {
                    const formattedData = {
                        value: item.group_exam_id,
                        label: item.exam_name,
                        subtype_id: item.schedule_sub_type_id,
                    };

                    this.setState({
                        selectedExamSubType: selectedOption,
                        selectedExamValue: formattedData,
                        adaptiveExamGroupData: adaptiveExamGroupExam,
                    }, () => {
                        this.getAdaptiveStudentsByGroupExamData(item.group_exam_id);
                    });
                } else {
                    this.setState({
                        selectedExamSubType: selectedOption,
                        adaptiveExamGroupData: adaptiveExamGroupExam,
                    });
                }
            }
        }
    }

    initializeFilterOptions = () => {
        const { globals } = this.props;
        if (!globals || !globals.globalBranches) return;

        const branchOptions = globals.globalBranches.map(b => ({
            value: Number(b.id),
            label: b.branch_name
        }));

        const branchIds = branchOptions.map(b => b.value);
        const examOptions = this.recalculateExams(branchIds);
        const examIds = examOptions.map(e => e.value);
        const classOptions = this.recalculateClasses(branchIds, examIds);
        const classIds = classOptions.map(c => c.value);
        const sectionOptions = this.recalculateSections(branchIds, examIds, classIds);

        this.setState({
            getBranchArr: branchOptions,
            branchSelectedvalue: branchOptions,
            getExamArr_filter: examOptions,
            examSelectedvalue_filter: examOptions,
            getClassArr_filter: classOptions,
            classSelectedvalue_filter: classOptions,
            getSectionArr_filter: sectionOptions,
            sectionSelectedvalue_filter: sectionOptions
        });
    }

    recalculateExams = (branchIds) => {
        const { globals } = this.props;
        if (!globals || !globals.b_e_c_s_data) return [];

        const uniqueExamIds = [...new Set(
            globals.b_e_c_s_data
                .filter(item => branchIds.includes(Number(item.branch_id)))
                .map(item => Number(item.exam_id))
        )];

        return uniqueExamIds.map(id => {
            const exam = globals.exams.find(e => Number(e.id) === id);
            return exam ? { value: Number(exam.id), label: exam.exam } : null;
        }).filter(Boolean);
    }

    recalculateClasses = (branchIds, examIds) => {
        const { globals } = this.props;
        if (!globals || !globals.b_e_c_s_data) return [];

        const uniqueClassIds = [...new Set(
            globals.b_e_c_s_data
                .filter(item =>
                    branchIds.includes(Number(item.branch_id)) &&
                    examIds.includes(Number(item.exam_id))
                )
                .map(item => Number(item.class_id))
        )];

        return uniqueClassIds.map(id => {
            const cls = globals.educationalClasses.find(c => Number(c.id) === id);
            return cls ? { value: Number(cls.id), label: cls.class } : null;
        }).filter(Boolean);
    }

    recalculateSections = (branchIds, examIds, classIds) => {
        const { globals } = this.props;
        if (!globals || !globals.b_e_c_s_data) return [];

        const uniqueSectionIds = [...new Set(
            globals.b_e_c_s_data
                .filter(item =>
                    branchIds.includes(Number(item.branch_id)) &&
                    examIds.includes(Number(item.exam_id)) &&
                    classIds.includes(Number(item.class_id))
                )
                .map(item => Number(item.section_id))
        )];

        return uniqueSectionIds.map(id => {
            const sec = globals.globalSections.find(s => Number(s.id) === id);
            return sec ? { value: Number(sec.id), label: sec.section_name } : null;
        }).filter(Boolean);
    }

    handleMultipleSelectInputChange = (e, name) => {
        if (name === "branch") {
            const branchIds = e.map(b => Number(b.value));
            if (branchIds.length === 0) {
                this.setState({
                    branchSelectedvalue: [],
                    examSelectedvalue_filter: [],
                    classSelectedvalue_filter: [],
                    sectionSelectedvalue_filter: [],
                    getExamArr_filter: [],
                    getClassArr_filter: [],
                    getSectionArr_filter: []
                });
                return;
            }
            const examOptions = this.recalculateExams(branchIds);
            const examIds = examOptions.map(i => i.value);
            const classOptions = this.recalculateClasses(branchIds, examIds);
            const classIds = classOptions.map(i => i.value);
            const sectionOptions = this.recalculateSections(branchIds, examIds, classIds);

            this.setState({
                branchSelectedvalue: e,
                getExamArr_filter: examOptions,
                examSelectedvalue_filter: examOptions,
                getClassArr_filter: classOptions,
                classSelectedvalue_filter: classOptions,
                getSectionArr_filter: sectionOptions,
                sectionSelectedvalue_filter: sectionOptions
            });
        } else if (name === "exam") {
            const branchIds = this.state.branchSelectedvalue.map(b => Number(b.value));
            const examIds = e.map(i => Number(i.value));
            if (examIds.length === 0) {
                this.setState({
                    examSelectedvalue_filter: [],
                    classSelectedvalue_filter: [],
                    sectionSelectedvalue_filter: [],
                    getClassArr_filter: [],
                    getSectionArr_filter: []
                });
                return;
            }
            const classOptions = this.recalculateClasses(branchIds, examIds);
            const classIds = classOptions.map(i => i.value);
            const sectionOptions = this.recalculateSections(branchIds, examIds, classIds);

            this.setState({
                examSelectedvalue_filter: e,
                getClassArr_filter: classOptions,
                classSelectedvalue_filter: classOptions,
                getSectionArr_filter: sectionOptions,
                sectionSelectedvalue_filter: sectionOptions
            });
        } else if (name === "class") {
            const branchIds = this.state.branchSelectedvalue.map(b => Number(b.value));
            const examIds = this.state.examSelectedvalue_filter.map(i => Number(i.value));
            const classIds = e.map(i => Number(i.value));
            if (classIds.length === 0) {
                this.setState({
                    classSelectedvalue_filter: [],
                    sectionSelectedvalue_filter: [],
                    getSectionArr_filter: []
                });
                return;
            }
            const sectionOptions = this.recalculateSections(branchIds, examIds, classIds);

            this.setState({
                classSelectedvalue_filter: e,
                getSectionArr_filter: sectionOptions,
                sectionSelectedvalue_filter: sectionOptions
            });
        } else if (name === "section") {
            this.setState({ sectionSelectedvalue_filter: e });
        }
    }

    actionsFormatter2(cell, row, rowIndex, formatExtraData) {
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-top">
                <Button variant="link" name="delete" className="text-danger"><i className="far fa-trash-alt" /></Button>
            </div>
        );
    }
    actionsFormatter1(cell, row, rowIndex, formatExtraData) {
        return (
            <React.Fragment>
                <div className="actions-buttons d-flex justify-content-center align-items-top">
                    <Button variant="link" name="edit" className="text-theme"><i className="far fa-edit" /></Button>
                </div>
            </React.Fragment>
        );
    }

    actionsFormatter(cell, row, rowIndex, formatExtraData) {
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-top">
                <Button variant="link" name="view" className="text-theme"><i className="far fa-eye" /></Button>
            </div>
        );
    }

    actionsFormatter12(cell, row, rowIndex, formatExtraData) {
        return (
            <div className="text-link">
                <Link className="text-dark" to={{}}>{row['exam_name']}</Link>
            </div>
        );
    }

    // Clamp long comma-separated values (e.g. Branch / Section lists) to a couple
    // of lines so a single row can't blow up the table height. Full text on hover.
    longTextFormatter = (cell) => {
        const text = cell == null ? "" : String(cell);
        return (
            <div
                title={text}
                style={{
                    maxWidth: 220,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: 1.3,
                }}
            >
                {text}
            </div>
        );
    }

    actionsFormatter13(cell, row, rowIndex, formatExtraData) {
        return (
            <div className="text-link">
                <a className="text-dark" href="/questions/manage-question-paper/question-paper-result">{row['branches']}</a>
            </div>
        );
    }


    handleEditFunction = (e, cell, row, rowIndex, formatExtraData) => {
        this.props.history.push("/questions/manage-question-paper/question-paper-result",
            {
                exam_id: rowIndex.id,
                is_completed: rowIndex.is_completed,

            });
    }

    handlePaperFunction = (e, cell, row, rowIndex, formatExtraData) => {
        this.props.history.push("/questions/proctoring-students",
            {
                exam_id: rowIndex.id,
                is_completed: rowIndex.is_completed,
            });
    }

    actionsFormatter3 = (cell, row, rowIndex, formatExtraData) => {
        const isCompleted = row?.is_completed?.toLowerCase() === "completed";

        return (
            <div
                className="actions-buttons d-flex justify-content-center align-items-top"
                style={{
                    cursor: isCompleted ? "not-allowed" : "pointer",
                }}
            >
                <Button
                    variant="link"
                    name="view"
                    className="text-theme"
                    disabled={isCompleted}
                    style={{
                        opacity: isCompleted ? 0.6 : 1,
                        pointerEvents: isCompleted ? "none" : "auto",
                    }}
                >
                    <i className="far fa-user" style={{
                        cursor: isCompleted ? "not-allowed" : "pointer",
                    }} />
                </Button>
            </div>
        );
    }


    // ── Role-based access control ──────────────────────────────────────────────
    // The row actions used to push a route (or fire the delete mutation) the moment
    // they were clicked, so a role without the grant was redirected into the target
    // page instead of being stopped. These guards keep the user on the list and show
    // the Access Denied modal instead of redirecting.
    //
    // Admins (userlevel 1/2) and roles with no configured grants keep full access —
    // see can() in utils/modulePermissions.
    //
    // NOTE: declared BEFORE articlecolumns on purpose — class fields initialise in
    // source order, and the column array captures these handlers by reference.
    showAccessDenied = () => this.setState({ accessDeniedShow: true });
    hideAccessDenied = () => this.setState({ accessDeniedShow: false });

    requireEdit = () => {
        if (canEdit(MANAGE_EXAMS_MODULE)) return true;
        this.showAccessDenied();
        return false;
    }

    requireDelete = () => {
        if (canDelete(MANAGE_EXAMS_MODULE)) return true;
        this.showAccessDenied();
        return false;
    }

    // Assigning which students may take the paper is a write → is_edit.
    handleSelectionFunction = (e, cell, row, rowIndex, formatExtraData) => {
        const isCompleted = rowIndex?.is_completed?.toLowerCase() === "completed";

        if (isCompleted) return;
        if (!this.requireEdit()) return;

        this.props.history.push("/questions/manage-question-paper/student-user-exam_access",
            {
                exam_id: rowIndex.id,
                is_completed: rowIndex.is_completed,
                tableData: rowIndex
            });
    }

    // Removing the paper → is_delete. The parent (ManageQuestionPaper) owns the
    // confirm + mutation; we only let the click through when the grant is there.
    handleDeleteFunction = (e, cell, row, rowIndex, formatExtraData) => {
        if (!this.requireDelete()) return;
        this.props.handleDelete(e, cell, row, rowIndex, formatExtraData);
    }

    getTableExams = (val) => {
        let someArray = val || [];
        let someArray1 = [];
        for (let i = 0; i < someArray.length; i++) {
            let idata = someArray[i];
            console.log("idata.is_completed", idata);
            let status = "";
            if (idata.is_completed == 0) {
                status = "Not completed";
            }
            else if (idata.is_completed == 1) {
                status = "completed";
            }
            else if (idata.is_completed == 2) {
                status = "On going";
            }
            const newObject = {
                id: idata.id,
                exam_name: idata.exam_name,
                exam_type: idata.exam_type,
                name: idata.name,
                branch: idata.branch,
                class: idata.class,
                class_id: idata.class_id,
                sub_exam_type: idata.sub_exam_type,
                section: idata.section,
                start_time: idata.start_time,
                end_time: idata.end_time,
                is_completed: status,
                filename: idata.filename,
                conducted_on: moment.unix(idata.start_time).format("DD-MM-YYYY"),
                time: moment.unix(idata.start_time).format("LT"),
                //conducted_on: moment.unix(idata.start_time).format("DD-MM-YYYY @ LT"),
                student_results: idata.student_results,
                result_graph: idata.result_graph,
                section_id: idata.section_id,
                //exam_questions: idata.exam_questions
            }
            someArray1.push(newObject);


        }
        return someArray1;
    }


    articlecolumns = [
        {
            dataField: "serial",
            text: "#",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "exam_name",
            text: "Exam Type",
            sort: true,
            formatter: this.actionsFormatter12,
            events: {
                onClick: this.handleEditFunction,
            }
        },
        {
            dataField: "name",
            text: "Exam",
            sort: true,

        },
        {
            dataField: "branch",
            text: "Branch",
            sort: true,
            formatter: this.longTextFormatter,
        },
        {
            dataField: "class",
            text: "class",
            sort: true
        },
        {
            dataField: "section",
            text: "Section",
            sort: true,
            formatter: this.longTextFormatter,
        },

        {
            dataField: "conducted_on",
            text: "Conducted On",
            sort: true,
            //sort: 'desc'
        },
        {
            dataField: "time",
            text: "time",
            //sort: true
        },

        // {
        //     dataField: "result",
        //     text: "Result",
        //     sort: true
        // },
        {
            dataField: "is_completed",
            text: "Status",
            // sort: true
        },
        {
            dataField: "actions",
            formatter: this.actionsFormatter,
            attrs: { className: "viewRow" },
            headerAlign: "center",
            events: {
                onClick: this.handleEditFunction,
            }
        },


        {
            dataField: "actions",
            formatter: this.actionsFormatter3,
            attrs: { className: "selectStudents" },
            headerAlign: "center",
            events: {
                onClick: this.handleSelectionFunction,
            }
        },

        // {
        //     dataField: "actions",
        //     text: "Actions",
        //     formatter: this.actionsFormatter1,
        //     attrs: { className: "EditRow" },
        //     headerAlign: "center",
        //     events: {
        //         onClick: this.handleEditFunction,
        //     }
        // },
        {
            dataField: "actions",
            // text: "Actions",
            formatter: () => (
                <>
                    <div className="actions-buttons d-flex justify-content-center align-items-start">
                        <Button
                            variant="link"
                            name="edit"
                            className="text-theme p-0"
                        >
                            <i className="fas fa-user-graduate"></i>
                        </Button>
                    </div>
                </>
            ),
            attrs: { className: "PaperRow" },
            headerAlign: "center",
            events: {
                onClick: this.handlePaperFunction,
            }
        },
        {
            dataField: "actions",
            formatter: this.actionsFormatter2,
            attrs: { className: "DeleteRow" },
            headerAlign: "center",
            events: {
                onClick: this.handleDeleteFunction,
            }
        }
    ];

    handleTabChange = (value) => {
        this.setState({ activeTab: value });
        // When embedded (e.g. inside the MIS Reports tab) don't change the URL —
        // just switch the inner tab in place.
        if (this.props.embedded) return;
        const slug = value === 2 ? "adaptive" : "general";
        this.props.history.push(`/questions/manage-question-paper/${slug}`);
    };


    selecthandleInputChange = (name, value, selectedOption) => {

        if (name === "selectedExamValue") {
            this.setState({
                [name]: selectedOption,
            });

            if (selectedOption?.value !== 0) {
                this.getAdaptiveStudentsByGroupExamData(selectedOption?.value);
            }

        } else {
            const adaptiveExamGroupExam = this.props.getAdaptiveExamGroups.filter((item) => item.schedule_sub_type_id === selectedOption?.value);
            const item = adaptiveExamGroupExam?.[0] || {};

            const formattedData = {
                value: item.group_exam_id,
                label: item.exam_name,
                subtype_id: item.schedule_sub_type_id,
            };
            this.getAdaptiveStudentsByGroupExamData(item.group_exam_id);
            this.setState({
                [name]: selectedOption,
                selectedExamValue: formattedData,
                adaptiveExamGroupData: adaptiveExamGroupExam,
            });
        }
    }


    getAdaptiveStudentsByGroupExamData = async (exam_id) => {
        this.setState({ loader: 1 });

        try {
            const result = await this.props.client.query({
                query: gql`
                            query($id:Int!){
                        getAdaptiveStudentsByGroupExam(id:$id){
                            student_name
    mobile
    exam_id
    exam
    branch_id
    branch_name
    class
    class_id
    section_id
    section_name
    exam_paper_id
                        }
                    } 
                          `,
                variables: {
                    id: parseInt(exam_id)
                },
                fetchPolicy: "network-only"
            });
            this.setState({
                loader: 0, selectedStudentModal: false,
                studentData: result?.data.getAdaptiveStudentsByGroupExam || [],
            });
        } catch (error) {
            console.log(error);
            this.setState({ loader: 0 });
        }
    };


    columns = [
        {
            dataField: "index",
            text: "#",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
            align: 'center',
            headerClasses: 'text-center',
        },
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
            formatter: this.nameFormatter.bind(this),
        },
        {
            dataField: "mobile",
            text: "Mobile",
            sort: true
        },
        {
            dataField: "branch_name",
            text: "Branch",
            sort: true
        },
        {
            dataField: "exam",
            text: "Exam",
            sort: true,
        },
        {
            dataField: "class",
            text: "Class",
            sort: true
        },
        {
            dataField: "section_name",
            text: "Section",
            sort: true
        },
    ];

    nameFormatter(cell, row, rowIndex) {
        return (
            <Link
                style={{ textDecoration: "none", color: "blue" }} // remove underline here
                to={{
                    pathname: "/adaptive-exam-students",
                    back: "/questions/manage-question-paper",
                    state: {
                        row: this.state,
                        rowIndex: rowIndex,
                        exam_paper_id: row.exam_paper_id,
                        exam_id: row.exam_id,
                        student_data: row,
                        type: "academic"
                    }
                }}
            >
                <span style={{ color: "#0d6efd", textDecorationColor: "#0d6efd", textDecoration: row.exam_name ? "underline" : "", cursor: "pointer" }}>
                    {row.student_name ?? "-"}
                </span>
            </Link>
        );
    };


    render() {
        console.log(this.props, "sefweofbweyiw")
        return (
            <section className="manage_question_papers">
                <div style={{ background: "#f8fafc", border: "1.5px solid #e2e8f0", borderRadius: 12, padding: "12px 16px 0 16px", marginTop: 16 }}>
                    <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                        {[
                            { value: 1, label: "General Exam", icon: "fal fa-file-alt" },
                            // { value: 2, label: "Adaptive Exam", icon: "fal fa-brain" },
                        ].map((tab) => {
                            const isActive = this.state.activeTab === tab.value;
                            return (
                                <li className="nav-item" key={tab.value}>
                                    <a
                                        className={`nav-link ${isActive ? "active" : ""}`}
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.handleTabChange(tab.value);
                                        }}
                                        style={{
                                            cursor: "pointer",
                                            fontWeight: 700,
                                            fontSize: 14,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                            padding: "12px 20px",
                                            color: isActive ? "#6366f1" : "#4b5563",
                                            background: isActive ? "#fff" : "transparent",
                                            borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                                            borderWidth: "1.5px",
                                            borderBottomWidth: isActive ? "2px" : "1.5px",
                                            borderRadius: "10px 10px 0 0",
                                            transition: "all 0.15s ease",
                                            marginBottom: "-1.5px",
                                        }}
                                    >
                                        <i className={tab.icon} />
                                        {tab.label}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>



                {
                    this.state.activeTab === 1 ? (
                        <>

                            <Row className="g-3 mt-3">
                                {[
                                    { label: "TOTAL EXAMS", value: this.props.globals.manageQuestionData.total, color: "#3d66f5", icon: "fal fa-file-alt" },
                                    { label: "ONGOING EXAMS", value: this.props.globals.manageQuestionData.ongoing, color: "#16a34a", icon: "fal fa-sync-alt" },
                                    { label: "COMPLETED EXAMS", value: this.props.globals.manageQuestionData.completed, color: "#db2777", icon: "fal fa-check-double" },
                                    { label: "FUTURE SCHEDULE EXAMS", value: this.props.globals.manageQuestionData.future, color: "#0891b2", icon: "fal fa-clock" },
                                ].map(({ label, value, color, icon }) => (
                                    <Col xl={3} lg={3} md={6} sm={6} xs={6} key={label}>
                                        <div style={{
                                            background: "#fff",
                                            border: "1px solid #e5e7eb",
                                            borderTop: `4px solid ${color}`,
                                            borderRadius: 16,
                                            padding: "18px 20px",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 16,
                                            marginBottom: 24,
                                        }}>
                                            <div style={{
                                                background: `${color}15`,
                                                color: color,
                                                borderRadius: 12,
                                                width: 50,
                                                height: 50,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexShrink: 0,
                                            }}>
                                                <i className={icon} style={{ fontSize: 22 }} />
                                            </div>
                                            <div>
                                                <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 600, letterSpacing: "0.5px" }}>{label}</div>
                                                <div style={{ fontSize: 24, fontWeight: 800, color: "#1f2937", lineHeight: 1.2 }}>{value}</div>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12}>
                                    <div className="card-title mb-0 text-danger">{this.props.stateData.status == 2 ? ("Exam deleted successfully") : ""}</div>
                                    <DataTableRemote
                                        parentData={(() => {
                                            const pageOffset = ((Number(this.props.page) || 1) - 1) * (Number(this.props.limit) || 10);
                                            return this.getTableExams(this.props.manageQuestions).map((r, i) => ({ ...r, serial: pageOffset + i + 1 }));
                                        })()}
                                        particlecolumns={this.articlecolumns}
                                        //defaultSorted={defaultSorted}
                                        tableHeading={this.state.tableHeaderData}
                                        remote={true}
                                        totalCount={this.props.totalCount}
                                        onPageChange={this.props.onPageChange}
                                        page={this.props.page}
                                        limit={this.props.limit}
                                        isPageLoading={this.props.isPageLoading}
                                    />
                                </Col>
                            </Row>
                        </>
                    ) : (
                        // <Container fluid>
                        //     <Row className="mt-3 d-flex justify-content-center">
                        //         <Col xl={12} lg={12} md={12} sm={12}>
                        //             <CardLessDataTableWithSearch
                        //                 parentData={this.props.getAdaptiveExamGroups}
                        //                 particlecolumns={this.columns}
                        //                 name="hostel_attendance"
                        //             />
                        //         </Col>
                        //     </Row>
                        // </Container>
                        <>

                            <Row className="justify-content-end mt-2 h-100">
                                {[
                                    {
                                        id: 1, label: "Sub Type", name: "selectedExamSubType", value: this.state.selectedExamSubType, options: [
                                            { value: 0, label: "Select Type" },
                                            ...this.props.getExamScheduleSubTypeQuestions.map(item => ({
                                                value: +item.schedule_sub_type_id,
                                                label: item.schedule_sub_type,
                                            }))
                                        ]
                                    },
                                    {
                                        id: 2, label: "Exam", name: "selectedExamValue", value: this.state.selectedExamValue, options: [
                                            { value: 0, label: "Select Exams" },
                                            ...this.state.adaptiveExamGroupData.map(item => ({
                                                value: item.group_exam_id,
                                                label: item.exam_name,
                                                subtype_id: item.schedule_sub_type_id,
                                            }))
                                        ]
                                    },
                                ].map(field => (

                                    <Col xl={3} lg={3} md={4} sm={12} key={field.id}>
                                        <Form.Group as={Row} className="align-items-center">
                                            <Col sm={12}>
                                                <Form.Label column className="fw-bold">
                                                    {field.label}
                                                </Form.Label>
                                                <SelectDropDown
                                                    stateData={field.value}
                                                    handleChange={this.selecthandleInputChange}
                                                    name={field.name}
                                                    options={field.options}
                                                    placeholderName={field.label}
                                                    dropdownIndicator={{ DropdownIndicator }}
                                                />

                                            </Col>
                                        </Form.Group>
                                    </Col>
                                ))
                                }
                            </Row>

                            {this.state.showFilter && (
                                <Card className="border-0 shadow-sm mt-3 mb-3">
                                    <Card.Body>
                                        <Row>
                                            {[
                                                { id: 1, name: "branch", label: "Branch", value: this.state.branchSelectedvalue, options: this.state.getBranchArr },
                                                { id: 2, name: "exam", label: "Exam", value: this.state.examSelectedvalue_filter, options: this.state.getExamArr_filter },
                                                { id: 3, name: "class", label: "Class", value: this.state.classSelectedvalue_filter, options: this.state.getClassArr_filter },
                                                { id: 4, name: "section", label: "Section", value: this.state.sectionSelectedvalue_filter, options: this.state.getSectionArr_filter },
                                            ].map(item => (
                                                <Col xl={3} lg={3} md={6} sm={12} key={item.id} className="mt-2">
                                                    <h6 className="text-uppercase fw-bold" style={{ fontSize: '12px' }}>{item.label}</h6>
                                                    <MultiSelect
                                                        options={item.options}
                                                        value={item.value}
                                                        onChange={(e) => this.handleMultipleSelectInputChange(e, item.name)}
                                                        labelledBy={item.label}
                                                        overrideStrings={{
                                                            allItemsAreSelected: `All ${item.label}s Selected`,
                                                            selectSomeItems: `Select ${item.label}`,
                                                        }}
                                                    />
                                                </Col>
                                            ))}
                                        </Row>
                                    </Card.Body>
                                </Card>
                            )}

                            <Container fluid>
                                {this.state.loader === 1 ? (
                                    <Container>
                                        <Row className="my-3">
                                            <Col>
                                                <div className="spinner-border text-primary text-center loading-img-center"></div>
                                            </Col>
                                        </Row>
                                    </Container>
                                ) : (
                                    <Row>
                                        {
                                            this.state.selectedExamValue?.value === 0 ? (
                                                <Col className="d-flex justify-content-center">
                                                    <h6>No Data Found</h6>
                                                </Col>
                                            ) : (
                                                <Col xl={12} lg={12} md={12} sm={12}>
                                                    {
                                                        this.state.studentData.length > 0 ? (
                                                            <CardLessDataTableWithSearch
                                                                parentData={(this.state.studentData || []).filter(student => {
                                                                    const branchMatch = this.state.branchSelectedvalue.length === 0 || this.state.branchSelectedvalue.some(b => Number(b.value) === Number(student.branch_id));
                                                                    const examMatch = this.state.examSelectedvalue_filter.length === 0 || this.state.examSelectedvalue_filter.some(e => Number(e.value) === Number(student.exam_id));
                                                                    const classMatch = this.state.classSelectedvalue_filter.length === 0 || this.state.classSelectedvalue_filter.some(c => Number(c.value) === Number(student.class_id));
                                                                    const sectionMatch = this.state.sectionSelectedvalue_filter.length === 0 || this.state.sectionSelectedvalue_filter.some(s => Number(s.value) === Number(student.section_id));
                                                                    return branchMatch && examMatch && classMatch && sectionMatch;
                                                                })}
                                                                particlecolumns={this.columns}
                                                                name="hostel_attendance"
                                                            />
                                                        ) : (
                                                            <Col className="d-flex justify-content-center">
                                                                <h6>No Data Found</h6>
                                                            </Col>
                                                        )
                                                    }
                                                </Col>
                                            )
                                        }
                                    </Row>
                                )}
                            </Container>
                        </>
                    )
                }


                {this.state.selectedStudentModal ?
                    <StudentAdaptiveExamReportModal
                        stateData={this.state}
                        show={this.state.selectedStudentModal}
                        onHide={() => this.setState({ selectedStudentModal: false })}
                    /> : null}

                {/* Shown instead of redirecting / deleting when the grant is missing. */}
                <Modal
                    show={this.state.accessDeniedShow}
                    onHide={this.hideAccessDenied}
                    centered
                    size="sm"
                    aria-labelledby="manage-exams-access-denied"
                >
                    <Modal.Body className="text-center" style={{ padding: "28px 24px" }}>
                        <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#fef2f2", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                            <i className="fal fa-lock-alt" style={{ fontSize: 26 }} />
                        </div>
                        <h5 id="manage-exams-access-denied" style={{ fontWeight: 800, color: "#0f172a", marginBottom: 8 }}>
                            Access Denied
                        </h5>
                        <p style={{ fontSize: 14, color: "#64748b", marginBottom: 20 }}>
                            You don't have permission to perform this action.
                        </p>
                        <Button variant="secondary" onClick={this.hideAccessDenied}>Close</Button>
                    </Modal.Body>
                </Modal>
            </section>
        )
    }
}

export default withRouter(withApollo(compose(

    // graphql(FETCH_EXAMS,

    //     {
    //         options: props => ({
    //             variables: {
    //                 institution_id: parseInt(Cookies.get("institutionid"))
    //             },
    //         }), name: "getExams"
    //     }), graphql(DELETE_EXAM, {
    //         name: "handleDelete"
    //     })
)(ManageQuestionPaperSection)));
